import React from 'react';
import PropTypes from 'prop-types';
import CallDetail from './callDetail';
import { ArrowDownIconSVG } from 's2s-svg-icons';
import { injectIntl } from 'react-intl';
import { getIntlText } from '../js/utilities';
import styled from 'styled-components';
import { colorGrid } from 's2s-themes';
import useCallInfo from "../hooks/callInfo";

const ComposedCallDetail = injectIntl(CallDetail);

const CallListContainer = styled.div`
  background-color: #F0F3FA;
  color: ${colorGrid.gray6};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: auto;
  width: 100%;
`;

const CallDetailList = styled.ul`
  list-style : none;
  margin : 0px;
  padding : 0px;
`;

const Divider = styled.li`
  align-items: center;
  display: flex;
  justify-content: center;
`;

const DefaultMessage = styled.div`
  padding : 16px;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.1px;
  color: #4C5863;
  font-family: "Open Sans";
`;

const arrowDownSVGStyles = {
  fill: 'rgba(0, 0, 0, 0.6)',
  height: '32px',
  width: '32px'
};

const ListHeader = styled.div`
  color: #001221;
  font-family: Poppins;
  font-size: 16px;
  padding: ${props => props.listHeader ? '4px 16px' : '0'};
`;

const CallList = (props) => {
  const [callInfo] = useCallInfo();

  // NOTE : this may need to be removed/renamed later since this is the same as activeCallOnClick().
  const transferCallOnClick = (callId) => {
    props.cbOnClick && props.cbOnClick(callInfo.inprogressCalls[callId]);
  };

  // NOTE : this may need to be removed/renamed later since this is the same as transferCallOnClick().
  const activeCallOnClick = (callId) => {
    props.cbOnClick && props.cbOnClick(callInfo.inprogressCalls[callId]);
  };

  const renderCallListZeroState = () => {
    return (
      <DefaultMessage className="DefaultMesssage" >
        {getIntlText(props.intl, 'CALLLIST-NOCALL', 'No Active call')}
      </DefaultMessage>
    );
  };

  const renderCallListItem = (key, cbCallerClick, callerObject = {}, ) => {
    console.log(callerObject);

    let call_name = '';
    if ( callerObject.callStatus==='merged') {
      call_name = Object.keys(callInfo.mergedCalls).map((callId) => {
        return callInfo.mergedCalls[callId].caller_name;
      }).join(' & ');
    }

    return (
      <React.Fragment key={key} >
        <ComposedCallDetail
          callId={callerObject.id} // NOTE : Value may need to change here.
          callerName={callerObject.callStatus==='merged' ? call_name : callerObject.caller_name}
          callerNumber={callerObject.caller_id}
          callStatus={callerObject.status}
          callStatusText={callerObject.status}
          cbClick={cbCallerClick}
          direction={callerObject.direction}
          isDate={false}
          isMuted={callerObject.isMuted}
          isOnHold={callerObject.isHeld}
          isSelected={(callerObject.callId === props.activeCallId) ? true : false}
          timestamp={callerObject.start_time}
          theme={props.theme}
        />
      </React.Fragment>
    );
  };

  const renderCallList = () => {
    let callDetailList;

    // TODO  SOFTPHONE-336 don't depend on listHeader value here.. (should be internationalized anyway).  use transferStatus

    if (callInfo.transferStatus === 'attendedTransfer') {

      const transferKey = callInfo.transferCallId && callInfo.inprogressCalls[callInfo.transferCallId] ? callInfo.inprogressCalls[callInfo.transferCallId].timestamp + '1' : 'xfer1';

      const transferDestinationKey = callInfo.transferDestinationCallId && callInfo.inprogressCalls[callInfo.transferDestinationCallId] ? callInfo.inprogressCalls[callInfo.transferDestinationCallId].timestamp + '3' : 'xfer3';


      callDetailList = (
        <CallDetailList className="CallDetailList" >
          {renderCallListItem(transferKey, transferCallOnClick, callInfo.inprogressCalls[callInfo.transferCallId])}
          <Divider
            className="Divider"
            key={callInfo.inprogressCalls[callInfo.transferDestinationCallId] ? callInfo.inprogressCalls[callInfo.transferDestinationCallId].timestamp + '2' : 'xfer2'}
          >
            <ArrowDownIconSVG
              className="ArrowDownIconSVG"
              svgStyle={arrowDownSVGStyles}
            />
          </Divider>
          {renderCallListItem(transferDestinationKey, activeCallOnClick, callInfo.inprogressCalls[callInfo.transferDestinationCallId])}
        </CallDetailList>
      );
    } else {
      callDetailList = (
        <CallDetailList className="CallDetailList">
          {Object.keys(callInfo.inprogressCalls).map((callId) => {
            const callIdFilter = (callInfo.transferStatus === 'initiateTransfer' ? (callInfo.transferCallId) : callId);
            if (callInfo.inprogressCalls[callId].id === callIdFilter) {
              // NOTE: This was always .callId but the data coming in didnt match so my items were never rendering here
              return renderCallListItem(callId, activeCallOnClick, callInfo.inprogressCalls[callId]);
            } else {
              return undefined;
            }
          })}
        </CallDetailList>
      );
    }

    return (
      <>
        <ListHeader
          className="ListHeader"
          listHeader={props.listHeader}
        >
          {props.listHeader}
        </ListHeader>
        {callDetailList}
      </>
    );
  };

  return (
    <CallListContainer className="CallListContainer" >
      {callInfo.inprogressCalls && Object.keys(callInfo.inprogressCalls).length > 0 ? renderCallList() : renderCallListZeroState()}
    </CallListContainer>
  );
};

//PropTypes.exact works like .shape does, but exact will give an error when an extra attribute is added.
CallList.propTypes = {
  cbOnClick: PropTypes.func,
  intl: PropTypes.object,
  listHeader: PropTypes.oneOf(['Transfer', 'Attended Transfer', undefined]),
};

CallList.defaultProps = {
  cbOnClick: () => { console.log("cbOnClick fired"); },
  listHeader: undefined
};

export default CallList;
